import {
  Banknote,
  BookOpen,
  Briefcase,
  Building2,
  CalendarDays,
  Coins,
  Compass,
  Factory,
  FileSignature,
  FileText,
  Flag,
  FlaskConical,
  Gem,
  Globe,
  GraduationCap,
  Handshake,
  Heart,
  Landmark,
  Leaf,
  Lightbulb,
  ListChecks,
  Mail,
  MapPin,
  Megaphone,
  Mic,
  Network,
  Newspaper,
  PiggyBank,
  Repeat,
  Rocket,
  Scale,
  ShieldCheck,
  Sprout,
  Star,
  Store,
  Tag,
  Target,
  Trophy,
  User,
  Users,
  Wrench,
  Zap,
  type LucideIcon,
} from 'lucide-react'

/**
 * The fixed icon set for categories and labels (spec-63, design §4.8), as lucide
 * names. `backend/app/crm/icons.py` holds the same list and
 * `backend/tests/test_crm_style_parity.py` compares the two.
 */
export const CRM_ICON_NAMES = [
  'tag',
  'star',
  'flag',
  'heart',
  'handshake',
  'users',
  'user',
  'building-2',
  'landmark',
  'factory',
  'store',
  'briefcase',
  'graduation-cap',
  'flask-conical',
  'lightbulb',
  'rocket',
  'sprout',
  'leaf',
  'coins',
  'piggy-bank',
  'banknote',
  'scale',
  'shield-check',
  'file-text',
  'file-signature',
  'mail',
  'megaphone',
  'newspaper',
  'calendar-days',
  'map-pin',
  'globe',
  'network',
  'repeat',
  'list-checks',
  'trophy',
  'gem',
  'zap',
  'target',
  'compass',
  'book-open',
  'wrench',
  'mic',
] as const

export type CrmIconName = (typeof CRM_ICON_NAMES)[number]

const ICONS: Record<CrmIconName, LucideIcon> = {
  tag: Tag,
  star: Star,
  flag: Flag,
  heart: Heart,
  handshake: Handshake,
  users: Users,
  user: User,
  'building-2': Building2,
  landmark: Landmark,
  factory: Factory,
  store: Store,
  briefcase: Briefcase,
  'graduation-cap': GraduationCap,
  'flask-conical': FlaskConical,
  lightbulb: Lightbulb,
  rocket: Rocket,
  sprout: Sprout,
  leaf: Leaf,
  coins: Coins,
  'piggy-bank': PiggyBank,
  banknote: Banknote,
  scale: Scale,
  'shield-check': ShieldCheck,
  'file-text': FileText,
  'file-signature': FileSignature,
  mail: Mail,
  megaphone: Megaphone,
  newspaper: Newspaper,
  'calendar-days': CalendarDays,
  'map-pin': MapPin,
  globe: Globe,
  network: Network,
  repeat: Repeat,
  'list-checks': ListChecks,
  trophy: Trophy,
  gem: Gem,
  zap: Zap,
  target: Target,
  compass: Compass,
  'book-open': BookOpen,
  wrench: Wrench,
  mic: Mic,
}

export function isCrmIcon(name: string): name is CrmIconName {
  return (CRM_ICON_NAMES as readonly string[]).includes(name)
}

/** The component for an icon name; an unknown name shows the tag icon (design §4.8). */
export function crmIcon(name: string | null | undefined): LucideIcon {
  return name && isCrmIcon(name) ? ICONS[name] : Tag
}
